import { Injectable } from '@angular/core';
import { Resource } from '../../auth/resources/resource';
import { Image } from '../../auth/models/image';

@Injectable()
export class UploadImageResource extends Resource {
  protected getEntity() {
    return 'loadImage';
  }

  protected map(item: unknown) {
    return new Image(item);
  }
}
